import classNames from "classnames";
import React, { FunctionComponent, ReactNode } from "react";
import { Anchor, Length, Unit } from "../../../../types/customization/box";
import {
  calcAbsolutePosition,
  lengthMmToPx,
  positionP10kToMm,
  sizeP10kToMm,
} from "../../../../utils/customization/box";
import "./style.scss";

interface Props {
  children: ReactNode;
  elementDimensions: {
    width: Length<Unit.P10K>;
    height: Length<Unit.P10K>;
    x: Length<Unit.P10K>;
    y: Length<Unit.P10K>;
    anchorSelf: Anchor;
    anchorPage: Anchor;
  };
  forced: boolean;
  pageDimensions: {
    width: Length<Unit.MM>;
    height: Length<Unit.MM>;
  };
  ppmm: number;
  zIndex: number;
}

const Box: FunctionComponent<Props> = ({
  children,
  pageDimensions,
  elementDimensions,
  forced,
  ppmm,
  zIndex,
}) => {
  const { anchorPage, anchorSelf } = elementDimensions;
  const elementSizeMm = sizeP10kToMm(elementDimensions, pageDimensions);

  const absolutePosition = calcAbsolutePosition<Unit.MM>({
    elementAnchor: anchorSelf,
    elementPosition: positionP10kToMm(elementDimensions, pageDimensions),
    elementSize: elementSizeMm,
    pageAnchor: anchorPage,
    pageSize: pageDimensions,
  });

  const style: {
    height: number;
    left: number;
    top: number;
    width: number;
    zIndex?: number;
  } = {
    height: lengthMmToPx(elementSizeMm.height, ppmm).value,
    left: lengthMmToPx(absolutePosition.x, ppmm).value,
    top: lengthMmToPx(absolutePosition.y, ppmm).value,
    width: lengthMmToPx(elementSizeMm.width, ppmm).value,
  };
  if (zIndex > 0) {
    style.zIndex = zIndex;
  }

  return (
    <div className={classNames("Box", { "Box--forced": forced })} style={style}>
      {children}
    </div>
  );
};

export default Box;
